import React from "react";

export const Shortcut = (props) => {
  return (
    <div id="shortcut" className="text-center">
      <div className="container">
        {/* 安卓 */}
        <div className="col-md-12">
          <img src="img/title-shortcut-a.png" className="img-title" alt="" />
        </div>
        <div className="row text-center">
          <div className="col-md-1 col-sm-1"></div>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <img src="img/shortcut/shortcut-a-02.jpg" className="img-content" alt="" />
          </div>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <img src="img/shortcut/shortcut-a-03.jpg" className="img-content" alt="" />
          </div>
          <div className="col-md-1 col-sm-1"></div>
        </div>
        {/* ios */}
        <div className="col-md-12">
          <img src="img/title-shortcut-i.png" className="img-title" alt="" />
        </div>
        <div className="row">
          <div className="col-md-1 col-sm-1"></div>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <img src="img/shortcut/shortcut-i-02.jpg" className="img-content" alt="" />
          </div>
          <div className="col-md-4 col-sm-4 col-xs-6">
            <img src="img/shortcut/shortcut-i-03.jpg" className="img-content" alt="" />
          </div>
          <div className="col-md-1 col-sm-1"></div>

        </div>

      </div>
    </div>
  );
};
